import * as actionTypes from "../../Actions/Main/ActionTypes";
import * as actionReducer from "./ActionReducer";

const initialState = {
  SocketConnection: null,
  MQTTConnection: null,
  socketState: "",
  mqttState: "",
  
  CurrentPlanId: null,
};

const MainReducer = (state = initialState, action) => {
  switch (action.type) {

    case actionTypes.SET_CURRENT_PLAN_ID:
      return actionReducer.setCurrentPlanId(state, action);

    case actionTypes.CLEAR_STATE:
      return actionReducer.clearState(state, action, initialState);


    case actionTypes.WEBSOCKET_CONNECTION:
      return { ...state, socketState: 'Socket is Connecting' };
    case actionTypes.WEBSOCKET_CONNECTION_SUCCESS:
      console.log("Socket is Connected!");
      return { ...state, SocketConnection: action.socketResponse, socketState: 'Connected' };
    case actionTypes.WEBSOCKET_CONNECTION_ERROR:
      console.log("** Socket FAILED! **");
      return { ...state, SocketConnection: null, socketState: 'Failed' };



    case actionTypes.MQTT_CONNECTION:
      return { ...state, mqttState: 'MQTT is Connecting' };
    case actionTypes.MQTT_CONNECTION_SUCCESS:
      console.log("MQTT is Connected!");
      return { ...state, MQTTConnection: action.mqttResponse, mqttState: 'Connected' };
    case actionTypes.MQTT_CONNECTION_ERROR:
      console.log("** MQTT FAILED! **");
      return { ...state, MQTTConnection: null, mqttState: 'Failed' };

    default:
      return state;
  }
};

export { MainReducer };